/** Combine microphone narration and optional shared-tab audio into one audio track. */
export async function createRecordingAudio(displayStream) {
  let microphone;
  let context;
  let destination;
  const sources = [];
  const release = () => {
    sources.forEach((source) => source.disconnect());
    microphone?.getTracks().forEach((track) => track.stop());
    destination?.stream.getTracks().forEach((track) => track.stop());
    if (context && context.state !== 'closed') context.close().catch(() => {});
  };

  try {
    microphone = await navigator.mediaDevices.getUserMedia({
      audio: { echoCancellation: true, noiseSuppression: true },
      video: false,
    });
    if (!microphone.getAudioTracks().length) {
      throw new Error('No microphone audio track is available.');
    }
    let audioTracks = microphone.getAudioTracks();
    if (displayStream.getAudioTracks().length) {
      context = new AudioContext();
      destination = context.createMediaStreamDestination();
      [displayStream, microphone].forEach((stream) => {
        const source = context.createMediaStreamSource(stream);
        sources.push(source);
        source.connect(destination);
      });
      await context.resume();
      audioTracks = destination.stream.getAudioTracks();
    }
    return {
      stream: new MediaStream([...displayStream.getVideoTracks(), ...audioTracks]),
      release,
    };
  } catch (error) {
    release();
    const message = error?.name === 'NotAllowedError'
      ? 'Microphone access was denied. Allow microphone access to record video with audio.'
      : error?.name === 'NotFoundError'
        ? 'No microphone was found. Connect a microphone to record video with audio.'
        : error?.message || 'Could not start audio recording.';
    throw new Error(message);
  }
}